import type {
  GridViewGridRefInstance,
  GridViewProps,
} from "@smartsuite/gridview/lib/components/GridView/GridView.types";
import React, { forwardRef, lazy, memo, Suspense } from "react";

import { AsyncGridIntlProvider } from "./AsyncGridIntlProvider";

const GridView = lazy(() => import("@smartsuite/gridview/lib/components/GridView/GridView"));

const GridViewWithLoaderInner = forwardRef<GridViewGridRefInstance, GridViewProps>(
  function GridViewWithLoaderInner(props, ref) {
    // Single Suspense boundary for both async intl (AsyncGridIntlProvider) and lazy GridView.
    return (
      <Suspense fallback={<div />}>
        <AsyncGridIntlProvider>
          <GridView {...props} ref={ref} />
        </AsyncGridIntlProvider>
      </Suspense>
    );
  },
);

GridViewWithLoaderInner.displayName = "GridViewWithLoaderInner";

export const GridViewWithLoader = memo(GridViewWithLoaderInner);
